import { fromJS } from 'immutable'
import {
  SHOW_MANUAL_TIMESHEET,
  CLOSE_MANUAL_TIMESHEET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SHOW_MANUAL_TIMESHEET:
      return state
        .set('isFetching', true)
        .set('isOpen', true)
    case CLOSE_MANUAL_TIMESHEET:
      return state
        .set('isFetching', false)
        .set('isOpen', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-manual-reducer.js